import { render, staticRenderFns } from "./PayMannerAllocation.vue?vue&type=template&id=0aac7d7b&scoped=true"
import script from "./PayMannerAllocation.vue?vue&type=script&lang=js"
export * from "./PayMannerAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac7d7b",
  null
  
)

export default component.exports